import useColor from '../../hook/useColor';
import useLogin from '../../hook/useLogin';
import useMerchant from '../../hook/useMerchant';
import { initMetaPixel, initGoogleAnalytics } from '../../utils/helper';
import useDevice from '../../hook/useDevice';
import { useSelector } from 'react-redux';
import { metaPixelId } from '../../utils/constants';
import useIdentifyCompany from '../../ufood-x/hook/useIdentifyCompany';
import ScrollToTop from '../ScrollToTop';
import useRelogin from '../../hook/useRelogin';

const Layout = ({ children }) => {
	const user = useSelector((store) => store?.user);

	useIdentifyCompany();
	useLogin();
	useColor();
	useMerchant();
	useRelogin();
	initMetaPixel(metaPixelId);
	initGoogleAnalytics(user?.googleAnalytic);
	useDevice();

	return (
		<>
			<div className='relative w-full h-full max-w-3xl mx-auto'>
				<div className='bg-white'>{children}</div>
			</div>
			<ScrollToTop />
		</>
	);
};

export default Layout;
